package org.gstechnovos.jexonplastech.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import org.gstechnovos.jexonplastech.components.Header
import org.gstechnovos.jexonplastech.components.SocialBar
import org.gstechnovos.jexonplastech.models.Section
import org.gstechnovos.jexonplastech.models.Theme
import org.gstechnovos.jexonplastech.styles.MainButtonStyle
import org.gstechnovos.jexonplastech.styles.MainImageStyle
import org.gstechnovos.jexonplastech.util.Constants
import org.gstechnovos.jexonplastech.util.Constants.LocalBreakpoint
import org.gstechnovos.jexonplastech.util.Constants.SECTION_WIDTH
import org.gstechnovos.jexonplastech.util.Res
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun MainSection(
    onMenuClick: () -> Unit
) {

    Box(
        modifier = Modifier.id(Section.Home.id).maxWidth(SECTION_WIDTH.px).minHeight(100.vh), contentAlignment = Alignment.TopCenter
    ) {
        MainBackground()
        MainContent(onMenuClick = onMenuClick)
    }

}

@Composable
fun MainBackground() {
    Image(
        src = Res.Image.BACKGROUND,
        modifier = Modifier.fillMaxSize().objectFit(ObjectFit.Cover),
        description = "Main background image"
    )
}

@Composable
fun MainContent(
    onMenuClick: () -> Unit
) {
    val breakPoint = LocalBreakpoint.current

    Column(
        modifier = Modifier.fillMaxSize(),
        verticalArrangement = Arrangement.SpaceBetween,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Header(onMenuClick = onMenuClick)
        Column(
            modifier = Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.Bottom,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SimpleGrid(
                modifier = Modifier.fillMaxWidth(if (breakPoint >= Breakpoint.MD) 80.percent else 90.percent).gap(20.px),
                numColumns = numColumns(base = 1, md = 2)
            ) {
                MainText()
                MainImage()
            }
        }

    }
}

@Composable
fun MainText() {

    val breakPoint = LocalBreakpoint.current

    Row(
        horizontalArrangement = Arrangement.Center, verticalAlignment = Alignment.CenterVertically
    ) {
        if (breakPoint > Breakpoint.MD) {
            SocialBar()
        }

        Column {
            P(
                attrs = Modifier.margin(topBottom = 0.px).fontFamily(Constants.FONT_FAMILY).fontSize(if (breakPoint>= Breakpoint.LG)45.px else 20.px).fontWeight(
                    FontWeight.Normal
                ).color(Theme.Primary.rgb).toAttrs()
            ) {
                Text("Hello, I'm")
            }

            P(
                attrs = Modifier.margin(top = 10.px, bottom = 0.px).fontFamily(Constants.FONT_FAMILY).fontSize(if (breakPoint>= Breakpoint.LG)68.px else 40.px).fontWeight(
                    FontWeight.Bold
                ).color(Theme.Secondary.rgb).toAttrs()
            ) {
                Text("Jexon Plastech.")
            }

            P(
                attrs = Modifier.margin(top = 10.px, bottom = 5.px).fontFamily(Constants.FONT_FAMILY).fontSize(20.px).fontWeight(
                    FontWeight.Bold
                ).color(Theme.Secondary.rgb).toAttrs()
            ) {
                Text("India's leading and quality maintain manufacturers of Household and Industrial Brushes.")
            }

            P(
                attrs = Modifier.margin( bottom = 25.px).maxWidth(400.px).fontFamily(Constants.FONT_FAMILY).fontSize(15.px).fontStyle(
                    FontStyle.Italic).fontWeight(
                    FontWeight.Normal
                ).color(Theme.Secondary.rgb).toAttrs()
            ) {
                Text(Constants.headerDescription)
            }

            Button(
                attrs = MainButtonStyle.toModifier().height(40.px).border(width = 0.px).borderRadius(5.px)
                    .backgroundColor(Theme.Primary.rgb)
                    .color(Colors.White).cursor(Cursor.Pointer).toAttrs()
            ) {
                Link(
                    modifier = Modifier.color(Colors.White).textDecorationLine(TextDecorationLine.None).fontSize(12.px),
                    text = "CONTACT US",
                    path = Section.Contact.path
                )
            }
        }
    }
}

@Composable
fun MainImage(){

    val breakpoint = LocalBreakpoint.current

    // On Desktop: Fill 80% of width.
    // On Mobile: Fill 100% of width.
    val boxWidth = if (breakpoint >= Breakpoint.MD) 80.percent else 100.percent

    // On Mobile: Give it a FIXED height so it doesn't overflow.
    // On Desktop: It can fill max height.
    val boxHeight = if (breakpoint >= Breakpoint.MD) 100.percent else 400.px

    Box(
        modifier = Modifier
            .fillMaxWidth(boxWidth)
            .height(boxHeight) // Apply the calculated height
            .borderRadius(10.percent)
            .overflow(Overflow.Hidden)
            .margin(bottom = 20.px), // Add margin so it doesn't touch the section below
        contentAlignment = Alignment.BottomCenter
    ) {
        Image(
            src = Res.Image.HEADER_IMAGE,
            modifier = MainImageStyle.toModifier()
                .fillMaxSize()
                .objectFit(ObjectFit.Cover),
            description = "header image"
        )
    }
}